// extracted by mini-css-extract-plugin
export var headerCell = "_7f-2";
export var rowWrapper = "_7f-4";
export var table = "_7f-1";
export var virtualRowWrapper = "_7f-5";
export var virtualTableContainer = "_7f-0";
export var white = "_7f-3";